(function(){
  if (!window.theme || !theme.wishlist || theme.wishlist.type !== 'local') { return; }

  function getStoredItems(){
    var raw = localStorage.getItem('kt-wishlist');
    if (!raw) return [];
    return raw.split(',').filter(function(v){ return v !== ''; });
  }

  function setStoredItems(items){
    localStorage.setItem('kt-wishlist', items.join(','));
    document.querySelectorAll('.wishlist-count').forEach(function(el){ el.textContent = items.length; });
  }

  function parseEntry(entry){
    var idx = entry.lastIndexOf(':');
    if (idx === -1) return { handle: entry, variantId: null };
    return { handle: entry.slice(0, idx), variantId: entry.slice(idx + 1) };
  }

  // A legacy entry (no variant saved) still matches, so nothing already
  // saved before this change disappears from a customer's wishlist.
  function entryMatches(entry, handle, variantId){
    var parsed = parseEntry(entry);
    if (parsed.handle !== handle) return false;
    if (parsed.variantId === null) return true;
    return String(parsed.variantId) === String(variantId);
  }

  function getVariantIdNear(el){
    var form = el.closest('form') || document.querySelector('form[action*="/cart/add"]');
    var input = form ? form.querySelector('[name="id"]') : document.querySelector('[name="id"]');
    return input ? input.value : (el.getAttribute('data-variant-id') || el.getAttribute('data-id'));
  }

  function refreshButton(btn){
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    var variantId = getVariantIdNear(btn);
    btn.setAttribute('data-variant-id', variantId || '');
    var items = getStoredItems();
    var isAdded = items.some(function(entry){ return entryMatches(entry, handle, variantId); });
    var nameEl = btn.querySelector('.btn-name');
    if (isAdded) {
      btn.classList.add('added');
      btn.setAttribute('data-action', 'view');
      btn.setAttribute('data-href', theme.wishlist.page_local);
      if (nameEl) nameEl.innerHTML = theme.wishlist.view;
    } else {
      btn.classList.remove('added');
      btn.setAttribute('data-action', 'add');
      btn.setAttribute('data-href', '#');
      if (nameEl) nameEl.innerHTML = theme.wishlist.add;
    }
  }

  function refreshAllButtons(){
    document.querySelectorAll('.kt-wishlist[data-handle]').forEach(refreshButton);
  }

  function buildWishlistRows(){
    var container = document.querySelector('.wishlist-page-items');
    if (!container) return;
    var items = getStoredItems();
    var tableEl = document.querySelector('.table-wishlist');
    var emptyEl = document.querySelector('.wishlist-empty');
    if (items.length === 0) {
      if (tableEl) tableEl.style.display = 'none';
      if (emptyEl) emptyEl.style.display = '';
      container.innerHTML = '';
      return;
    }
    if (tableEl) tableEl.style.display = '';
    if (emptyEl) emptyEl.style.display = 'none';
    var rowsHtml = items.map(function(entry){
      var parsed = parseEntry(entry);
      var includeUrl = window.Shopify.root_url + '/products/' + parsed.handle + '?view=wishlist-local';
      if (parsed.variantId) { includeUrl += '&variant=' + parsed.variantId; }
      var rowId = entry.replace(/[^a-zA-Z0-9_-]/g, '-');
      return '<tr class="wishlist-page-item lazyload" id="WishItem-' + rowId + '" data-wishlist-entry="' + entry + '" data-include="' + includeUrl + '">'
        + '<td class="product-col"><div class="product d-flex align-content-stretch"><figure class="product-media"><div class="lz-place"></div></figure><div class="w-100"><div class="lz-place"></div></div></div></td>'
        + '<td class="price-col"><div class="lz-place"></div></td>'
        + '<td class="stock-col"><div class="lz-place"></div></td>'
        + '<td class="action-col"><div class="lz-place"></div></td>'
        + '<td class="remove-col"><div class="lz-place"></div></td>'
      + '</tr>';
    }).join('');
    container.innerHTML = rowsHtml;
    if (window.theme && typeof theme.lazyListener === 'function') {
      theme.lazyListener('.wishlist-page-items');
    }
  }

  function addToWishlist(btn){
    var handle = btn.getAttribute('data-handle');
    var variantId = getVariantIdNear(btn);
    if (!handle || !variantId) return;
    var items = getStoredItems();
    var already = items.some(function(e){ return entryMatches(e, handle, variantId); });
    if (!already) {
      items.push(handle + ':' + variantId);
      setStoredItems(items);
    }
    refreshAllButtons();
  }

  function removeFromWishlist(handle, variantId){
    var items = getStoredItems().filter(function(entry){ return !entryMatches(entry, handle, variantId); });
    setStoredItems(items);
    refreshAllButtons();
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest ? e.target.closest('.kt-wishlist') : null;
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      if (btn.getAttribute('data-action') === 'view') {
        window.location.href = btn.getAttribute('data-href');
        return;
      }
      addToWishlist(btn);
      return;
    }
    var removeEl = e.target.closest ? e.target.closest('.wishlist-remove') : null;
    if (removeEl) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      var row = removeEl.closest('[data-wishlist-entry]');
      var entry = row ? row.getAttribute('data-wishlist-entry') : null;
      if (entry) {
        var parsed = parseEntry(entry);
        removeFromWishlist(parsed.handle, parsed.variantId);
        if (row) {
          row.style.transition = 'opacity .3s';
          row.style.opacity = '0';
          setTimeout(function(){
            row.remove();
            if (getStoredItems().length === 0) {
              var tableEl = document.querySelector('.table-wishlist');
              var emptyEl = document.querySelector('.wishlist-empty');
              if (tableEl) tableEl.style.display = 'none';
              if (emptyEl) emptyEl.style.display = '';
            }
          }, 300);
        }
      }
    }
  }, true);

  document.addEventListener('change', function(e){
    if (e.target && e.target.name === 'id') {
      refreshAllButtons();
    }
  });

  var lastKnownVariantId = null;
  function pollVariantChange(){
    var btn = document.querySelector('.kt-wishlist[data-handle]');
    if (!btn) return;
    var currentId = getVariantIdNear(btn);
    if (currentId !== lastKnownVariantId) {
      lastKnownVariantId = currentId;
      refreshAllButtons();
    }
  }
  setInterval(pollVariantChange, 400);

  var watching = false;
  var rebuilding = false;
  function watchWishlistContainer(){
    if (watching) return;
    var container = document.querySelector('.wishlist-page-items');
    if (!container) return;
    watching = true;
    var mo = new MutationObserver(function(){
      if (rebuilding) return;
      var firstRow = container.querySelector('.wishlist-page-item');
      if (firstRow && !firstRow.hasAttribute('data-wishlist-entry')) {
        rebuilding = true;
        buildWishlistRows();
        rebuilding = false;
      }
    });
    mo.observe(container, { childList: true });
  }

  function init(){
    refreshAllButtons();
    buildWishlistRows();
    watchWishlistContainer();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();